import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission,
  IceResponsiveMattableSettings,
  IceResponsiveMattableEditSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { accountingfilter } from '../../../../icemedx-lib/src/models/accounting/accountingfilter';
import { Validators, FormControl } from '@angular/forms';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { expensejournal } from '../../../../icemedx-lib/src/models/accounting/expensejournal';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { liabilityjournal } from '../../../../icemedx-lib/src/models/accounting/liabilityjournal';
import { otheritemsjournal } from '../../../../icemedx-lib/src/models/accounting/otheritemsjournal';
import { Observable } from 'rxjs';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { accountingperiodindex } from '../../../../icemedx-lib/src/models/accounting/accountingperoidindex';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { AppConstants } from '../app-constants';

const SelectDestinationPeriod = "EMPTY";

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class LedgerComponent implements OnInit, IBaseView {

  // data members
  disablePeriod: boolean = false;
  lastSelectedAccountingPeriod: string = "";
  filters: any = {};
  currentFilter: accountingfilter = null;
  showJournal: boolean = true;

  moveTo: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "450px" }, null, null, "MoveTo", "Move Selected to Accounting Period")
    .setControlName("MoveTo")
    .createFormControl(SelectDestinationPeriod, []).setOptions([
      { name: "<Select Destination Period>", value: SelectDestinationPeriod },
      { name: "<Undefined Accounting Period>", value: "" }
    ]);
  moveToCanceButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Cancel Move", glyphClass: "fas fa-times", width: "50px" }, null, null, "Cancel Move");

  journalDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  // Journal Entry
  journEntryDomainType: IcecontrolSettings = null;
  journEntryDomainNameCtrl: IcecontrolSettings = null;
  journEntryDateCtrl: IcecontrolSettings = null;
  journEntryDescCtrl: IcecontrolSettings = null;
  journEntryCoaTypeCtrl: IcecontrolSettings = null;
  journEntryQuantityCtrl: IcecontrolSettings = null;
  journEntryAmountCtrl: IcecontrolSettings = null;
  journEntryCodeCtrl: IcecontrolSettings = null;
  journEntryIncreaseCtrl: IcecontrolSettings = null;

  // member settings
  journalTypeCtrl: IcecontrolSettings = null;
  coaTypeCtrl: IcecontrolSettings = null;
  fromDateCtrl: IcecontrolSettings = null;
  toDateCtrl: IcecontrolSettings = null;
  ledgerListSettings: IcepanelcontainerSettings = null;
  ledgerPermission: IcecontrolPermission = null;
  debitTotalControl: IcecontrolSettings = new IcecontrolSettings("icelabel", { class: ["grand-total ice-lg-padding-left"], value: "Total Debits: " }, {}, {}, "DebitTotal", "")
    .setControlName("DebitTotal")
    .createFormControl(0, []);
  creditTotalControl: IcecontrolSettings = new IcecontrolSettings("icelabel", { class: ["grand-total ice-lg-padding-left"], value: "Total Credits: " }, {}, {}, "CreditTotal", "")
    .setControlName("CreditTotal")
    .createFormControl(0, []);
  totalSection: IcepanelsectionSettings = new IcepanelsectionSettings("TotalSection", { class: [""], styles: { width: "100%" } }, null, [this.debitTotalControl, this.creditTotalControl], [])
    .setShow(true);

  journalTable: IceResponsiveMattableSettings = null;
  tableTagJournal: string = "JournalTable";

  sectionTagNewEntry: string = "NewEntry";

  newEntry: any = {};
  deleteConfirmationDialogRef: any = null;
  accountToSearch: string = "";

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private acctSvc: AccountingService,
    private router: Router,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService) {

    this.appSvc.defaultMenus();
    this.addBreadcrumbs();

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufAccountingJournals).default_access;
    this.ledgerPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufAccountingJournals, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.filters[IceTypes.JournalType.jtAsset] = new accountingfilter([], IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaNone);
    this.ledgerListSettings = this.viewSetup(this.filters[IceTypes.JournalType.jtAsset]);
  }

  addBreadcrumbs() {
    this.breadcrumbService.updateBreadcrumbs({
      TREE: this.getAccountingBreadcrumb(),
      BRANCH: { display: "Ledger", data: null, active: true, link: "/accounting/ledger", history: [] }
    });
  }

  getAccountingBreadcrumb() {
    return { display: "Accounting", data: null, active: false, link: "/accounting/summary", history: [] };
  }

  ngOnInit() {
    this.appSvc.refreshMenus();

    // get the breadcrumbs to see if there's a patient in the YARD
    let data: any = this.breadcrumbService.getYardData();
    if (Iceutility.isdefined(data.account)) {
      this.accountToSearch = data.account;
    }

    this.activatedRoute.fragment.subscribe(data => {
      if (Iceutility.isdefined(data)) {

        this.domainSvc.getPatient(data, this.appSvc.getCurrentAccount())
          .subscribe(result => {
            if (Iceutility.isdefined(result) && result.length > 0) {
              let patientName = "";
              let patient: patient = result[0];
              let entity: entity = Iceutility.isdefined(patient.ENTS) && patient.ENTS.length > 0 ? patient.ENTS[0] : null;
              if (entity) {
                patientName = `${entity.first_name} ${entity.last_name}`;
              }

              this.searchJournals(this.lastSelectedAccountingPeriod, patient.trans_account);

              this.breadcrumbService.updateBreadcrumbs({
                TREE: this.getAccountingBreadcrumb(),
                YARD: {
                  display: patientName,
                  data: null,
                  active: true,
                  link: "",
                  history: []
                }
              });
            }
          });
      }
    });
  }

  viewSetup(dat: IceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufAccountingJournals).default_access;

      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
        return null;
      }
      if (dat == null) {
        return null;
      }

      /////////////////////////
      // 
      this.currentFilter = <accountingfilter>dat;

      //////////////////////
      // Results
      let jrnlTables = this.viewJournalTables(this.currentFilter.dataJournal, []);
      let jrnlSections = this.viewJournalSection(jrnlTables, [], true);

      let jrnlfrm: IcepanelSettings = new IcepanelSettings("JournalView", "", "Journal", "", jrnlSections, null, null)
        .enableForm();

      let nameFrmGrp = jrnlfrm.getForm();
      let panels: IcepanelSettings[] = [
        jrnlfrm,
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("JournalViewContainer", panelrows);

      this.acctSvc.getPeriods(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let opts = this.moveTo.getOptions();
            for (let i = 0; i < data.length; i++) {
              let actper: accountingperiodindex = <accountingperiodindex>data[i];

              let periodDesc = AccountingService.getPeriodDesc(actper, AccountingService.getPeriodStatus(<IceTypes.period_status>Iceutility.toLong(actper.status)));
              opts.push({ value: actper.accounting_period_key, name: periodDesc });
            }
            this.moveTo.setOptions(opts);
          }
        },
        error => {
        }
      );
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  viewJournalTables(results: any[], codes: string[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {
      let chkCtrl: IcecontrolSettings = new IcecontrolSettings("icecheckbox", { width: "50px", cursor: 'pointer' }, null, null, null)
          .setControlName()
          .createFormControl(false, []);

      this.journalTable = new IceResponsiveMattableEditSettings(
        this.tableTagJournal,
        [
          new iceColumnDefinition("select", "", false, false, chkCtrl),
          new iceColumnDefinition("journal_date", "Date", false, false,
            new IcecontrolSettings("icelabel", { width: "200px" }, null, null)),
          new iceColumnDefinition("coa_type", "Account", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Account", width: "100px" }, null, null)),
          new iceColumnDefinition("journal_desc", "Description", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Description", width: "150px" }, null, null)),
          new iceColumnDefinition("journal_code", "Code", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Code", width: "50px" }, null, null)),
          new iceColumnDefinition("last_name", "Name", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Name", width: "150px" }, null, null)),
          new iceColumnDefinition("journal_note", "Post Ref. Note", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Post Ref. Note", width: "100px" }, null, null)),
          new iceColumnDefinition("quantity", "Qty.", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Qty.", width: "50px" }, null, null)),
          new iceColumnDefinition("debit", "Debit", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Debit", width: "50px" }, null, null)),
          new iceColumnDefinition("credit", "Credit", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Credit", width: "50px" }, null, null)),
          new iceColumnDefinition("amount", "amount", true),
          new iceColumnDefinition("increase", "increase", true),
          new iceColumnDefinition("journal_key", "journal_key", true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.journalDataSource,
        [IceTypes.recordQuickActionEdit, IceTypes.recordQuickActionViewBalance, IceTypes.recordQuickActionViewBucket, IceTypes.recordQuickActionViewHistory, IceTypes.recordQuickActionRemove],
        false,
        null,
        true, null, false
      ).showAddButton(true);

      tables.push(this.journalTable);

      if (results != null && results.length > 0) {
        this.journalDataSource.data = results;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewJournalSection(tables: IceResponsiveMattableSettings[], idCodeList: string[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let resultsGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      //////////////////////
      // Filter
      let jrnlType = ""
      let coaType: IceTypes.coa_types = IceTypes.coa_types.coaNone;
      if (this.currentFilter != null) {
        jrnlType = this.currentFilter.journal;
        coaType = this.currentFilter.coa_type;
      }

      this.journalTypeCtrl = new IcecontrolSettings("iceselect", { menuItems: AccountingService.getJournalTypeList(), width: "200px" }, null, null, "JournalType", "Select Journal Type")
        .setControlName("JournalType")
        .createFormControl(jrnlType, []);

      this.coaTypeCtrl = new IcecontrolSettings("iceselect", { menuItems: AccountingService.getCoaTypeList(), width: "200px" }, null, null, "CoaType", "Select Type")
        .setControlName("CoaType")
        .createFormControl(coaType, []);

      let toDate = Iceutility.GetLocalDate();
      this.fromDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", value: "", timevalue: "00:00:00 AM" }, null, null, "FromDate")
        .setControlName("FromDate")
        .createFormControl("", [Validators.required]);
      this.toDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", value: toDate, timevalue: "11:59:59 PM" }, null, null, "ToDate")
        .setControlName("ToDate")
        .createFormControl(toDate, [Validators.required]);

      let filterControls: IcecontrolSettings[] = [
        this.journalTypeCtrl,
        //this.coaTypeCtrl,
        //this.fromDateCtrl,
        //this.toDateCtrl,
      ];

      sections.push(
        new IcepanelsectionSettings("JournalFilterViewSection", { class: [""], styles: { width: "100%" } }, [], filterControls, null),
        this.totalSection
      );

      ////////////////////////
      // New Entry
      this.journEntryDomainType = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "account_type", "Type of Domain or Entity") 
        .setControlName("account_type")
        .createFormControl(0, [Validators.required]);

      this.journEntryDomainType.setOptions(DomainService.getDomainTypes());

      this.journEntryDomainNameCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "475px" }, null, null, "trans_account", "Enter Name of Network Domain")
        .setControlName("trans_account")
        .createFormControl("", [Validators.required]);

      this.journEntryDateCtrl = new IcecontrolSettings("icedatepicker", { width: "475px" }, null, null, "journal_date", "Enter Date of Entry")
        .setControlName("journal_date")
        .createFormControl(Iceutility.getDateTextEx(Iceutility.GetLocalDate()), [Validators.required]);

      this.journEntryDescCtrl = new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "journal_desc", "Enter Description of Entry")
        .setControlName("journal_desc")
        .createFormControl("", [Validators.required]);

      this.journEntryCoaTypeCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "coa_type", "Select Account of Entry")
        .setControlName("coa_type")
        .createFormControl(IceTypes.coa_types.coaNone, [Validators.required]);

      this.journEntryCoaTypeCtrl.setOptions(AccountingService.getCoaTypeList());

      this.journEntryCodeCtrl = new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "journal_code", "Enter Code i.e. 0001 or A11000")
        .setControlName("journal_code")
        .createFormControl(0, [Validators.required]);

      this.journEntryAmountCtrl = new IcecontrolSettings("iceinput", { width: "475px", inputType: "number" }, null, null, "amount", "Enter Entry Amount")
        .setControlName("amount")
        .createFormControl(0, [Validators.required]);

      this.journEntryIncreaseCtrl = new IcecontrolSettings("iceselect", { width: "475px", menuItems: [{ name: "Increase", value: true }, { name: "Decrease", value: false }] }, null, null, "increase", "Select Entry Action")
        .setControlName("increase")
        .createFormControl(true, [Validators.required]);

      this.journEntryQuantityCtrl = new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "quantity", "Enter Related Quantity (if any)")
        .setControlName("quantity")
        .createFormControl(0, []);

      let idControls = [
        this.journEntryDomainType,
        this.journEntryDomainNameCtrl,
        this.journEntryDateCtrl,
        this.journEntryDescCtrl,
        this.journEntryCoaTypeCtrl,
        this.journEntryCodeCtrl,
        this.journEntryAmountCtrl,
        this.journEntryIncreaseCtrl,
        this.journEntryQuantityCtrl
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagNewEntry, idControls));

      //////////////////////////
      // Results
      sections.push(
        new IcepanelsectionSettings("JournalResultsViewSection", { class: [""], styles: { width: "100%" } }, resultsGroups, [], null)
      );
/*
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("QUANTITYUNITOFMEASURE"), this.invUnitCtrl, []);
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, []);
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, []);
*/
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  getJournalType(): IceTypes.JournalType {
    let ret: IceTypes.JournalType = IceTypes.JournalType.jtAsset;
    let ctrAction: FormControl = this.journalTypeCtrl.getFormControl();
    if (ctrAction != null) {
      ret = ctrAction.value;
    }

    return ret;
  }

  getNetworkType(): IceTypes.ACCOUNT_TYPE {
    let ret: IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.journEntryDomainType.getFormControl();
    if (ctrType != null) {
      ret = ctrType.value;
    }
    return ret;
  }

  getNetworkDomain(): any {
    let ret = null;
    let ordDomainControl: FormControl = this.journEntryDomainNameCtrl.getFormControl();
    if (ordDomainControl != null && ordDomainControl.value != null && ordDomainControl.value.length > 0) {
      try {
        let domObj = JSON.parse(ordDomainControl.value);
        if (domObj == null || domObj.length == 0) throw "Invalid account selection.";
        ret = domObj;
      }
      catch (e) {
        console.log(e);
      }
    }
    return ret;
  }

  showMoveTo(): boolean {
    let jrnlType = this.getJournalType();
    let actFilter: accountingfilter  = <accountingfilter>this.filters[jrnlType];
    if (actFilter == null) return false;

    return actFilter.hasSelection();
  }

  searchJournals(acctPer: string, accountFilter: string = "") {
    let jrnlType = this.getJournalType();
    this.debitTotalControl.getFormControl().setValue(0.0);
    this.creditTotalControl.getFormControl().setValue(0.0);
    this.journalDataSource.data = [];
    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", jrnlType, IceTypes.coa_types.coaNone, "", IceTypes.coa_types.coaNone, acctPer).subscribe(
      data => {
        if (data != null) {
          console.log(data);
          if (!Iceutility.isStringUndefinedNullOrEmpty(accountFilter)) {
            data = data.filter(d => d.trans_account === accountFilter);
          }
          this.filters[jrnlType] = null;
          if (this.lastSelectedAccountingPeriod.length == 0) {
            let foundUndefinedPer = data.filter(a => a.accounting_period_key == this.lastSelectedAccountingPeriod);
            this.filters[jrnlType] = new accountingfilter(foundUndefinedPer, jrnlType, IceTypes.coa_types.coaNone);
          }
          else {
            this.filters[jrnlType] = new accountingfilter(data, jrnlType, IceTypes.coa_types.coaNone);
          }

          let acctFilter: accountingfilter = <accountingfilter>this.filters[jrnlType];
          this.debitTotalControl.getFormControl().setValue(acctFilter.debitTotal);
          this.creditTotalControl.getFormControl().setValue(acctFilter.creditTotal);

          if (this.journalDataSource.data == null) this.journalDataSource.data = [];
          this.journalDataSource.data = this.filters[jrnlType].dataJournal;
        }
      },
      error => {
        console.log(error);
      });
  }

  /////////////////////////////////////
  // Events
  onControlChange(event) {
    if (event.selectSettings != null) {
      switch (event.selectSettings.id) {
        case "JournalType": {
          this.searchJournals(this.lastSelectedAccountingPeriod);
          break;
        }
        case "account_type": {
          switch (this.getNetworkType()) {
            case IceTypes.ACCOUNT_TYPE.actPatient: {
              // Fall through and do lookup upon keyword search
              break;
            }
            //case IceTypes.ACCOUNT_TYPE.actProvider:
            //case IceTypes.ACCOUNT_TYPE.actFacility: {
            //  this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.proSvc.getProviders());
            //  break;
            //}
            //case IceTypes.ACCOUNT_TYPE.actPharmacy: {
            //  this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.pharmSvc.getPharmacies());
            //  break;
            //}
            //case IceTypes.ACCOUNT_TYPE.actVendor: {
            //  this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.vendorSvc.getVendors());
            //  break;
            //}
            //case IceTypes.ACCOUNT_TYPE.actPayer: {
            //  this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.payerSvc.getPayers());
            //  break;
            //}
            case IceTypes.ACCOUNT_TYPE.actSubscriber: {
              // Fall through and do lookup upon keyword search
              break;
            }
            default: {
              // To do error to user
              return;
            }
          }
          break;
        }
      }
    }
    else if (event.buttonSettings != null) {
    }
    else if (event.autocompleteSettings != null) {
    }
    else if (Iceutility.isdefined(event.autocompleteQuerySettings)) {
      switch (event.autocompleteQuerySettings.id) { // To do: Move this to the new autocompleteQuery event
        case "trans_account": {
          if (event["value"] != null && event["value"].length >= 3) {
            switch (this.getNetworkType()) {
              case IceTypes.ACCOUNT_TYPE.actPatient: {
                this.appSvc.setDomainNameList(this.journEntryDomainNameCtrl, true, this.domainSvc.getPatientsByKeyword(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actSubscriber: {
                this.appSvc.setDomainNameList(this.journEntryDomainNameCtrl, true, this.domainSvc.getSubscribersByKeyword(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
                break;
              }
            }
          }
          break;
        }
      }
    }
  }

  onButtonClick(event) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case "xxx": {
          //let itemEntryFrm = this.ctrlBillingDomainItemEntryCtrl.getFormControl();
          //if (itemEntryFrm != null)
          //  this.processItemEntry(itemEntryFrm.value, "");
          break;
        }
        default: {
          // Add New Item to DB
          if (this.appSvc.processEditPanelSectionButtons(this.sectionTagNewEntry, event.buttonSettings.id)) {
            let jrnlType = this.journalTypeCtrl.getFormControl().value;
            let dom = this.getNetworkDomain();
            if (dom == null || dom.length == 0) {
              break;
            }

            this.newEntry[jrnlType]["journal_date"] = Iceutility.convertToUTCEx(this.newEntry[jrnlType]["journal_date"]);
            this.newEntry[jrnlType]["last_name"] = dom[0]["name"];
            this.newEntry[jrnlType]["trans_account"] = dom[0]["value"];
            this.newEntry[jrnlType]["coa_type"] = this.journEntryCoaTypeCtrl.getFormControl().value;
            this.newEntry[jrnlType]["account_type"] = this.journEntryDomainType.getFormControl().value;
            this.newEntry[jrnlType]["journal_code"] = this.journEntryCodeCtrl.getFormControl().value;
            let offstatus = this.newEntry[jrnlType].offline_record_status;
            let amt = this.journEntryAmountCtrl.getFormControl().value;
            let incr = this.journEntryIncreaseCtrl.getFormControl().value;
            let entryToSubmit = this.currentFilter.copyEntry(this.newEntry[jrnlType]);

            switch (jrnlType) {
              case IceTypes.JournalType.jtAsset: {
                let jrnl: assetjournal = new assetjournal(<assetjournal>entryToSubmit);
                jrnl.asset_journal_key = entryToSubmit.journal_key;
                this.insertUpdateResults(jrnlType, offstatus, this.acctSvc.insertUpdateAssetJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), amt, incr, jrnl));
                break;
              }
              case IceTypes.JournalType.jtExpense: {
                let jrnl: expensejournal = new expensejournal(<expensejournal>entryToSubmit);
                jrnl.expense_journal_key = entryToSubmit.journal_key;
                this.insertUpdateResults(jrnlType, offstatus, this.acctSvc.insertUpdateExpenseJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), amt, incr, jrnl));
                break;
              }
              case IceTypes.JournalType.jtIncome: {
                let jrnl: incomerevenuejournal = new incomerevenuejournal(<incomerevenuejournal>entryToSubmit);
                jrnl.income_revenue_journal_key = entryToSubmit.journal_key;
                this.insertUpdateResults(jrnlType, offstatus, this.acctSvc.insertUpdateIncomeJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), amt, incr, jrnl));
                break;
              }
              case IceTypes.JournalType.jtLiability: {
                let jrnl: liabilityjournal = new liabilityjournal(<liabilityjournal>entryToSubmit);
                jrnl.liability_journal_key = entryToSubmit.journal_key;
                this.insertUpdateResults(jrnlType, offstatus, this.acctSvc.insertUpdateLiabilityJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), amt, incr, jrnl));
                break;
              }
              case IceTypes.JournalType.jtInventory: {
                let jrnl: otheritemsjournal = new otheritemsjournal(<otheritemsjournal>entryToSubmit);
                jrnl.other_items_journal_key = entryToSubmit.journal_key;
                this.insertUpdateResults(jrnlType, offstatus, this.acctSvc.insertUpdateOtherItemsJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), amt, incr, jrnl));
                break;
              }
            }
          }
          else if (this.appSvc.getEditPanelSectionCancelID(this.sectionTagNewEntry) == event.buttonSettings.id) {
            let cancelJrnlType = this.journalTypeCtrl.getFormControl().value;
            let dom = this.getNetworkDomain();
            if (dom == null || dom.length == 0) {
              break;
            }


          }
          break;
        }
      }
    }
  }

  onPeriodChange(event) {
    this.lastSelectedAccountingPeriod = event.value;
    this.searchJournals(this.lastSelectedAccountingPeriod, this.accountToSearch);
  }

  onPeriodActionRequired(event) {
    if (event.value == "NoCurrentPeriod") {
      this.showJournal = false;
    }
    else {
      this.showJournal = true;
      if (event.value == "NewPeriod" && event["selected"] != null) {
        let opts = this.moveTo.getOptions();
        opts.push(event["selected"]);
        this.moveTo.setOptions(opts);
      }
    }
  }

  private insertUpdateResults(jrnlType: IceTypes.JournalType, offstatus: number, results: Observable<any>) {
    results.subscribe(
      data => {
        if (data == null || data.length == 0) return;
        if (this.newEntry[jrnlType] == null) return;
        if (this.journalDataSource.data == null) this.journalDataSource.data = [];

        let entryItem = data[0];
        if (entryItem == null) return;

        this.newEntry[jrnlType] = this.currentFilter.updateEntry(entryItem, offstatus == IceTypes.offlineRecStatus.offlineInsert);
        if (offstatus == IceTypes.offlineRecStatus.offlineInsert) {
          this.currentFilter.originalData.push(entryItem);
          this.journalDataSource.data.push(this.newEntry[jrnlType]);
          this.journalDataSource.data = this.journalDataSource.data;
        }

        // Reset;
        this.newEntry[jrnlType] = null;
      },
      error => {
        // To do, log error
      });
  }

  public onAddRowButtonClick(event) {
    let jrnlType = this.journalTypeCtrl.getFormControl().value;
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case this.tableTagJournal: {
          this.appSvc.showEditPanelSection(this.sectionTagNewEntry);
          this.newEntry[jrnlType] = null; // reset
          switch (jrnlType) {
            case IceTypes.JournalType.jtAsset: {
              this.newEntry[jrnlType] = new assetjournal();
              this.newEntry[jrnlType].asset_journal_key = Iceutility.guid(true);
              this.newEntry[jrnlType].offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              this.appSvc.editPanelSectionUpdate(this.sectionTagNewEntry, false, this.newEntry[jrnlType]);
              break;
            }
            case IceTypes.JournalType.jtExpense: {
              this.newEntry[jrnlType] = new expensejournal();
              this.newEntry[jrnlType].expense_journal_key = Iceutility.guid(true);
              this.newEntry[jrnlType].offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              this.appSvc.editPanelSectionUpdate(this.sectionTagNewEntry, false, this.newEntry[jrnlType]);
              break;
            }
            case IceTypes.JournalType.jtIncome: {
              this.newEntry[jrnlType] = new incomerevenuejournal();
              this.newEntry[jrnlType].income_revenue_journal_key = Iceutility.guid(true);
              this.newEntry[jrnlType].offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              this.appSvc.editPanelSectionUpdate(this.sectionTagNewEntry, false, this.newEntry[jrnlType]);
              break;
            }
            case IceTypes.JournalType.jtLiability: {
              this.newEntry[jrnlType] = new liabilityjournal();
              this.newEntry[jrnlType].liability_journal_key = Iceutility.guid(true);
              this.newEntry[jrnlType].offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              this.appSvc.editPanelSectionUpdate(this.sectionTagNewEntry, false, this.newEntry[jrnlType]);
              break;
            }
            case IceTypes.JournalType.jtInventory: {
              this.newEntry[jrnlType] = new otheritemsjournal();
              this.newEntry[jrnlType].other_items_journal_key = Iceutility.guid(true)
              this.appSvc.editPanelSectionUpdate(this.sectionTagNewEntry, false, this.newEntry[jrnlType]);
              break;
            }
          }
          break;
        }
      }
      setTimeout(_ => {
        window.scrollTo(0, 0);
      }, 500);
    }
  }

  onMatGridRowActionClick(event) {
    if (event.actionItem == null) return;
    let entry = event["rowData"];
    if (entry == null) {
      // To do log error
      return;
    }

    let jrnlType = this.journalTypeCtrl.getFormControl().value;
    let item = null;
    switch (jrnlType) {
      case IceTypes.JournalType.jtAsset: {
        item = <assetjournal>entry;
        break;
      }
      case IceTypes.JournalType.jtExpense: {
        item = <expensejournal>entry;
        break;
      }
      case IceTypes.JournalType.jtIncome: {
        item = <incomerevenuejournal>entry;
        break;
      }
      case IceTypes.JournalType.jtLiability: {
        item = <liabilityjournal>entry;
        break;
      }
      case IceTypes.JournalType.jtInventory: {
        item = <otheritemsjournal>entry;
        break;
      }
    }

    let navigationExtras: NavigationExtras = {
      fragment: AppConstants.LedgerPage
    };

    if (IceTypes.recordQuickActionEdit.value == event.actionItem.value) {

      let jrnlType = this.journalTypeCtrl.getFormControl().value;
      this.appSvc.showEditPanelSection(this.sectionTagNewEntry, 0);
      this.newEntry[jrnlType] = entry;

      this.newEntry[jrnlType].journal_date = Iceutility.GetLocalDate(Iceutility.convertToUTCEx(this.newEntry[jrnlType].journal_date));

      this.newEntry[jrnlType].account_type = Iceutility.toLong(this.newEntry[jrnlType].account_type);
      if (this.newEntry[jrnlType].last_name == null || this.newEntry[jrnlType].last_name.length == 0) {
        this.newEntry[jrnlType].last_name = "Not Specified";
      }

      if (this.newEntry[jrnlType].trans_account == null) {
        this.newEntry[jrnlType].trans_account = "";
      }
      else {
        this.newEntry[jrnlType].trans_account = JSON.stringify([{ name: this.newEntry[jrnlType].last_name, value: this.newEntry[jrnlType].trans_account }]);
      }

      this.newEntry[jrnlType].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
      this.appSvc.editPanelSectionUpdate(this.sectionTagNewEntry, false, this.newEntry[jrnlType]);
    }
    else if (IceTypes.recordQuickActionRemove.value == event.actionItem.value) {
      this.showDeleteConfirmation(jrnlType, entry);
    }
    else if (IceTypes.recordQuickActionViewBalance.value == event.actionItem.value
      || IceTypes.recordQuickActionViewBucket.value == event.actionItem.value) {

      if (item != null) {
        this.acctSvc.getBillByService(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), item.trans_account, item.account_type, item.medical_service_key).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let bills: superbillcharges[] = <superbillcharges[]>data;
              if (IceTypes.recordQuickActionViewBalance.value == event.actionItem.value)
                this.router.navigate([this.navSvc.buildRoute("accounting/outstandingbalance/" + bills[0].superbill_charges_key, false)], navigationExtras);
              else
                this.router.navigate([this.navSvc.buildRoute("accounting/serviceitemcharge/" + bills[0].superbill_charges_key, false)], navigationExtras);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else if (IceTypes.recordQuickActionViewHistory.value == event.actionItem.value) {
      if (item != null) {
        this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory/byservice/" + item.account_type.toString() + "/" + item.trans_account, false)], navigationExtras);
      }
    }
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    //this.router.navigate([this.navSvc.buildRoute("viewreport/" + event.rowData.report_key, false)]);
  }

  moveToCancelClick(event) {
    let jrnlType = this.getJournalType();
    let actFilter: accountingfilter = <accountingfilter>this.filters[jrnlType];
    if (actFilter == null) return;
    for (let i = 0; i < actFilter.dataJournal.length; i++) {
      let jrnl = actFilter.dataJournal[i];
      jrnl.select = false;
    }
    this.searchJournals(this.lastSelectedAccountingPeriod);
  }

  moveToChange(event) {
    let jrnlType = this.getJournalType();
    let actFilter: accountingfilter = <accountingfilter>this.filters[jrnlType];
    if (actFilter == null) return;
    let moveToPeriod = this.moveTo.getFormControl().value;
    if (SelectDestinationPeriod == moveToPeriod) {
      Iceutility.yesnomodal("You must select a destination period.");
      return;
    }

    if (this.lastSelectedAccountingPeriod == moveToPeriod) {
      Iceutility.yesnomodal("These journal item(s) are already in the destination period.");
      return;
    }

    let tableName = null;
    let jrnlsToMove = [];
    for (let i = 0; i < actFilter.dataJournal.length; i++) {
      let jrnl = actFilter.dataJournal[i];
      if (jrnl.select == false) continue;

      switch (jrnlType) {
        case IceTypes.JournalType.jtAsset: {
          if (tableName == null) tableName = new assetjournal().gettablename();
          let astjrl = new assetjournal(<assetjournal>jrnl);
          astjrl.asset_journal_key = jrnl.journal_key;
          jrnlsToMove.push(astjrl);
          jrnl.select = false;
          break;
        }
        case IceTypes.JournalType.jtExpense: {
          if (tableName == null) tableName = new expensejournal().gettablename();
          let expjrl = new expensejournal(<expensejournal>jrnl);
          expjrl.expense_journal_key = jrnl.journal_key;
          jrnlsToMove.push(expjrl);
          jrnl.select = false;
          break;
        }
        case IceTypes.JournalType.jtIncome: {
          if (tableName == null) tableName = new incomerevenuejournal().gettablename();
          let incjrl = new incomerevenuejournal(<incomerevenuejournal>jrnl);
          incjrl.income_revenue_journal_key = jrnl.journal_key;
          jrnlsToMove.push(incjrl);
          jrnl.select = false;
          break;
        }
        case IceTypes.JournalType.jtLiability: {
          if (tableName == null) tableName = new liabilityjournal().gettablename();
          let liajrl = new liabilityjournal(<liabilityjournal>jrnl);
          liajrl.liability_journal_key = jrnl.journal_key;
          jrnlsToMove.push(liajrl);
          jrnl.select = false;
          break;
        }
        case IceTypes.JournalType.jtInventory: {
          if (tableName == null) tableName = new otheritemsjournal().gettablename();
          jrnlsToMove.push();
          let otmjrl = new otheritemsjournal(<otheritemsjournal>jrnl);
          otmjrl.other_items_journal_key = jrnl.journal_key;
          jrnlsToMove.push(otmjrl);
          jrnl.select = false;
          break;
        }
      }
    }

    if (jrnlsToMove.length > 0) {
      this.acctSvc.moveJournals(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), tableName, jrnlsToMove, this.lastSelectedAccountingPeriod, moveToPeriod).subscribe(
        data => {
          this.moveTo.getFormControl().setValue(SelectDestinationPeriod);
          this.searchJournals(this.lastSelectedAccountingPeriod);
        },
        error => {
          this.searchJournals(this.lastSelectedAccountingPeriod);
        }
      );
    }
  }

  private showDeleteConfirmation(journalType, record) {
    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px", tooltip: "Delete" }, null, null, "Delete"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Close" }, null, null, "Close")
    ];

    let sections = [
      new IcepanelsectionSettings("section1", { class: [""], styles: {} }, [],
        [new IcecontrolSettings("icelabel", { width: "200px", value: "Are you sure you want to delete this record?" }, null, null)], null)
    ];
      
    this.deleteConfirmationDialogRef = this.dialog.open(IcepanelDialog, {
      height: '200px',
      width: '550px',
      data: {
        journalType: journalType,
        record: record,
        panel: new IcepanelSettings("", "", "Delete Record?", "", sections, headerControls)
          .enableForm(),
      }
    });

    let dialogRef = this.deleteConfirmationDialogRef;
    this.deleteConfirmationDialogRef.afterClosed().subscribe(result => {
      if (!Iceutility.isdefined(dialogRef.componentInstance) || !Iceutility.isdefined(dialogRef.componentInstance.data)) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>dialogRef.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let journalToDelete = dialogRef.componentInstance.data.record;

      switch (dialogRef.componentInstance.data.journalType) {
        case IceTypes.JournalType.jtAsset: {
          this.acctSvc.deleteAssetJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), journalToDelete.journal_key).subscribe(
            data => {
              this.journalDataSource.data = this.journalDataSource.data.filter(j => j.journal_key != journalToDelete.journal_key);
            }, error => { });
          break;
        }
        case IceTypes.JournalType.jtExpense: {
          this.acctSvc.deleteExpenseJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), journalToDelete.journal_key).subscribe(
            data => {
              this.journalDataSource.data = this.journalDataSource.data.filter(j => j.journal_key != journalToDelete.journal_key);
            }, error => { });
          break;
        }
        case IceTypes.JournalType.jtIncome: {
          this.acctSvc.deleteIncomeJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), journalToDelete.journal_key).subscribe(
            data => {
              this.journalDataSource.data = this.journalDataSource.data.filter(j => j.journal_key != journalToDelete.journal_key);
            }, error => { });
          break;
        }
        case IceTypes.JournalType.jtInventory: {
          this.acctSvc.deleteInventoryJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), journalToDelete.journal_key).subscribe(
            data => {
              this.journalDataSource.data = this.journalDataSource.data.filter(j => j.journal_key != journalToDelete.journal_key);
            }, error => { });
          break;
        }
        case IceTypes.JournalType.jtLiability: {
          this.acctSvc.deleteLiabilityJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), journalToDelete.journal_key).subscribe(
            data => {
              this.journalDataSource.data = this.journalDataSource.data.filter(j => j.journal_key != journalToDelete.journal_key);
            }, error => { });
          break;
        }
      }
    });
  }

  onToolbarMenuItemClick(event) {
    if (Iceutility.isdefined(event) && Iceutility.isdefined(event.selectedItem) && Iceutility.isdefined(event.selectedItem.data)) {
      this.accountToSearch = event.selectedItem.data.account;
      this.searchJournals(this.lastSelectedAccountingPeriod, this.accountToSearch);
    }
  }
}
